// extracted by mini-css-extract-plugin
export default {"loaderSpinner":"spinner_loaderSpinner__i+r1b","l3":"spinner_l3__18QFu"};